export const SCREEN_NAME = 'POINT_OF_CONTACT';
